// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"46f042bd","453":"cea21074","455":"a226389b","977":"9f13e3d9"}[chunkId] + ".chunk.js";
};